/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/motorcycle'
export default icon
